import(/* webpackMode: "eager" */ "/home/runner/work/agentx/agentx/apps/web/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ImpersonationBanner"] */ "/home/runner/work/agentx/agentx/apps/web/components/ImpersonationBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InstallHint"] */ "/home/runner/work/agentx/agentx/apps/web/components/InstallHint.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MicPermissionModal"] */ "/home/runner/work/agentx/agentx/apps/web/components/MicPermissionModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileBottomNav"] */ "/home/runner/work/agentx/agentx/apps/web/components/MobileBottomNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegister"] */ "/home/runner/work/agentx/agentx/apps/web/components/ServiceWorkerRegister.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopBarClient"] */ "/home/runner/work/agentx/agentx/apps/web/components/TopBarClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UpdateNotifier"] */ "/home/runner/work/agentx/agentx/apps/web/components/UpdateNotifier.tsx");
